import React, { useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { Link } from "react-router-dom";

const faqs = [
  {
    question: "What services does Bizwit Insights provide?",
    answer: (
      <span>
        At <span className="font-bold">Bizwit Insights</span>, we offer a
        comprehensive suite of services designed to help businesses make
        informed, data-driven decisions. Our services include:
        <ul className="list-disc pl-6 mt-2">
          <li>Market Research Reports</li>
          <li>Consumer Insights & KPIs Reporting</li>
          <li>Custom Research & Consulting</li>
          <li>Competitive Analysis & Bench marking</li>
          <li>ESG Consulting & Sustainability Reports</li>
          <li>Industry Trend Analysis</li>
          <li>Business Intelligence Solutions</li>
        </ul>
      </span>
    ),
  },

  {
    question: "How do I know which service is right for my business?",
    answer:
      "Each business has unique needs. If you're unsure which service to choose, we recommend scheduling a consultation with one of our experts. We'll assess your current challenges and goals to guide you toward the most suitable solution.",
  },
  {
    question: "What industries do you cover in your reports?",
    answer: (
      <span>
        We cover a broad range of industries including:
        <ul className="list-disc pl-6 mt-2">
          <li>Technology & Media</li>
          <li>Healthcare & Pharmaceuticals</li>
          <li>Consumer Goods & Retail</li>
          <li>Manufacturing & Construction</li>
          <li>Financial Services</li>
          <li>Energy & Utilities</li>
          <li>Automotive & Transportation</li>
          <li>Food & Beverages</li>
        </ul>
        For a full list of industries, Eamil us at{" "}
        <Link
          to="mailto: insights@bizwitresearch.com"
          className="text-[#0C7FDA] underline hover:text-blue-700 font-medium"
        >
           insights@bizwitresearch.com
        </Link>{" "}
        .
      </span>
    ),
  },
  {
    question:
      "What is a Market Research Report, and how can it benefit my business?",
    answer:
      "A Market Research Report provides in-depth analysis and insights into a specific market or industry. These reports include data on market size, trends, growth opportunities, competitive landscape, and consumer behaviour. Businesses use these reports to understand the market dynamics and make strategic decisions that improve growth and profitability.",
  },
  {
    question:
      "What is Consumer Insights: KPIs Reporting, and why is it important?",
    answer: (
      <span>
        Consumer Insights: KPIs Reporting is a service that provides businesses
        with key performance indicators (KPIs) based on consumer behaviour,
        preferences, and market trends. This reporting helps companies:
        <ul className="list-disc pl-6 mt-2">
          <li>Understand customer satisfaction levels</li>
          <li>Track engagement and retention</li>
          <li>Monitor product performance</li>
          <li>Optimize marketing strategies</li>
        </ul>
        By leveraging these insights, businesses can better align their
        offerings with consumer needs and drive growth.
      </span>
    ),
  },
  {
    question:
      "Can I request a custom research report specific to my business needs?",
    answer:
      "Yes, we offer Custom Research & Consulting services tailored to your business's specific challenges and objectives. Whether you're entering a new market, launching a product, or looking to gain a competitive edge, we will design a research solution that meets your unique requirements.",
  },
  {
    question: "What is ESG Consulting, and how does it benefit businesses?",
    answer: (
      <span>
        Environmental, Social, and Governance (ESG) Consulting helps businesses
        integrate sustainability and ethical practices into their core
        strategies. We provide services like:
        <ul className="list-disc pl-6 mt-2">
          <li>ESG Strategy Development</li>
          <li>ESG Risk Management</li>
          <li>ESG Reporting & Disclosures</li>
          <li>Stakeholder Engagement</li>
          <li>Decarbonization Plans</li>
        </ul>
        By adopting ESG principles, companies can not only comply with
        regulatory requirements but also build trust with investors, customers,
        and other stakeholders, contributing to long-term growth.
      </span>
    ),
  },
  {
    question:
      "What is the difference between a syndicated research report and custom research?",
    answer: (
      <span>
        <ul className="list-disc pl-6 mt-2">
          <li>
            Syndicated Research Reports are pre-prepared reports that provide
            comprehensive data and insights on specific industries or markets.
            These reports are available for purchase off-the-shelf.
          </li>
          <li>
            Custom Research is tailored to the specific needs of a business. We
            collect data and provide insights that are unique to your
            challenges, goals, and market.
          </li>
        </ul>
        <p className="mt-3">
          If you need a broad overview of an industry, syndicated reports are
          ideal. If your business has specific requirements, custom research is
          the best option.
        </p>
      </span>
    ),
  },

  {
    question: "How frequently are your reports updated?",
    answer:
      "Our reports are updated regularly to reflect the latest market trends, data, and regulatory changes. This ensures that you receive the most current and relevant information to make informed decisions.",
  },
  {
    question: "What geographic regions do your reports cover?",
    answer: (
      <span>
        Our research covers a wide range of geographic regions, including:
        <ul className="list-disc pl-6 mt-2 mb-2">
          <li>North America</li>
          <li>Europe</li>
          <li>Asia-Pacific</li>
          <li>Latin America</li>
          <li>Middle East & Africa</li>
        </ul>
        We also offer country-specific reports for more targeted insights.
        
        <Link
          to="/contact-us"
          className="text-[#0C7FDA] underline hover:text-blue-700 ml-1 font-medium"
        >
          Contact Us
        </Link>{" "}
        for more details.
      </span>
    ),
  },
  {
    question: "How can I access your reports?",
    answer:
      "You can access our reports by purchasing them directly from our website. If you require custom research, you can contact us to discuss your needs and receive a tailored proposal.",
  },
  {
    question: "What is included in a Competitive Analysis Report?",
    answer: (
      <span>
        Our Competitive Analysis & Benchmarking reports provide a detailed
        overview of your competitors' strengths, weaknesses, market positions,
        and strategies. The report includes:
        <ul className="list-disc pl-6 mt-2">
          <li>Market share analysis</li>
          <li>SWOT analysis</li>
          <li>Product comparisons</li>
          <li>Pricing strategies</li>
          <li>Benchmarking against industry leaders</li>
        </ul>
        This helps businesses stay competitive and identify opportunities for
        differentiation.
      </span>
    ),
  },
  {
    question:
      "What are Industry Trend Reports, and how can they help my business?",
    answer: (
      <span>
        Industry Trend Reports analyse key developments and trends within a
        specific industry, including technological advancements, regulatory
        changes, consumer preferences, and market dynamics. These reports help
        businesses:
        <ul className="list-disc pl-6 mt-2">
          <li>Anticipate future market shifts</li>
          <li>Identify emerging opportunities</li>
          <li>Adapt to changes in demand</li>
        </ul>
        Staying informed of industry trends ensures that your business remains
        competitive and innovative.
      </span>
    ),
  },
  {
    question:
      "What is the typical turnaround time for custom research projects?",
    answer:
      "Turnaround times for Custom Research depend on the complexity and scope of the project. However, we strive to deliver comprehensive and actionable reports within an agreed-upon timeframe, typically ranging from a few weeks to a few months.",
  },
  {
    question:
      "How do I know if my business needs ESG Consulting or Market Research?",
    answer: `If your business is facing regulatory challenges, looking to build sustainable growth strategies, or needs to improve investor and stakeholder trust, ESG Consulting is essential.
If you're exploring new markets, launching products, or optimizing performance, Market Research will provide you with valuable insights to make data-driven decisions.
Feel free to consult with our experts to assess your business needs.
`,
  },
  {
    question: "How do I contact Bizwit Insights for more information?",
    answer: (
      <span>
        You can contact us through our{" "}
        <Link
          to="/contact-us"
          className="text-[#0C7FDA] underline hover:text-blue-700 font-medium"
        >
          Contact Us
        </Link>{" "}
        page on our website or reach out directly via email at{" "}
        <Link
          to="mailto:info@bizwitinsights.com"
          className="text-[#0C7FDA] hover:underline hover:text-blue-700 font-medium"
        >
          info@bizwitinsights.com
        </Link>
        . We are here to help with any questions or requests for proposals.
      </span>
    ),
  },
];

const HelpFaq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8 pt-4 pb-16 sm:pb-24">
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-4 sm:mb-6 font-inter">
        Help and FAQs
      </h2>

      <div className="">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="border-b border-gray-300 py-3 sm:py-4 lg:py-5 transition-all duration-200 hover:bg-gray-50"
          >
            <div
              className="flex justify-between items-start sm:items-center cursor-pointer gap-4"
              onClick={() => toggleFAQ(index)}
            >
              <h3 className="text-base sm:text-lg lg:text-xl font-semibold font-poppins pr-8">
                {faq.question}
              </h3>
              <div className="flex-shrink-0 mt-1 sm:mt-0">
                {activeIndex === index ? (
                  <FiChevronUp className="text-lg sm:text-xl text-[#1c1b1f]" />
                ) : (
                  <FiChevronDown className="text-lg sm:text-xl text-[#1c1b1f]" />
                )}
              </div>
            </div>

            {activeIndex === index && (
              <div className="mt-2 sm:mt-3 font9 whitespace-pre-line font-poppins text-sm sm:text-base lg:text-lg transition-all duration-300 ease-in-out">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default HelpFaq;
